import React, { useEffect } from "react";
import funnel from "../../styles/Funnel.module.css";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";

function Transportation({ formData, setFormData }) {
  const handleChange = (e) => {
    const { value, checked } = e.target;
    const { Transportation } = formData;

    if (checked) {
      setFormData({
        ...formData,
        Transportation: [...Transportation, value],
      });
    } else {
      setFormData({
        ...formData,
        Transportation: Transportation.filter((e) => e !== value),
      });
    }
  };

  let Train = (
    <FormControlLabel
      control={
        <Checkbox
          name="Transportation"
          value="train"
          onChange={handleChange}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Train (railway)"
    />
  );

  let Tram = (
    <FormControlLabel
      control={
        <Checkbox
          name="Transportation"
          value="tram"
          onChange={handleChange}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Tram (light railway)"
    />
  );

  let Metro = (
    <FormControlLabel
      control={
        <Checkbox
          name="Transportation"
          value="metro"
          onChange={handleChange}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Metro (Subway-Tube)"
    />
  );

  let Ferry = (
    <FormControlLabel
      control={
        <Checkbox
          name="Transportation"
          value="ferry"
          onChange={handleChange}
          sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
        />
      }
      label="Ferry"
    />
  );

  for (const item in formData.Transportation) {
    if (formData.Transportation[item] == "train") {
      Train = (
        <FormControlLabel
          control={
            <Checkbox
              name="Transportation"
              value="train"
              onChange={handleChange}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Train (railway)"
        />
      );
    } else if (formData.Transportation[item] == "tram") {
      Tram = (
        <FormControlLabel
          control={
            <Checkbox
              name="Transportation"
              value="tram"
              onChange={handleChange}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Tram (light railway)"
        />
      );
    } else if (formData.Transportation[item] == "metro") {
      Metro = (
        <FormControlLabel
          control={
            <Checkbox
              name="Transportation"
              value="metro"
              onChange={handleChange}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Metro (Subway-Tube)"
        />
      );
    } else if (formData.Transportation[item] == "ferry") {
      Ferry = (
        <FormControlLabel
          control={
            <Checkbox
              name="Transportation"
              value="ferry"
              onChange={handleChange}
              sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }}
              checked
            />
          }
          label="Ferry"
        />
      );
    }
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <div className={funnel.boxQn}>
        <h2 className={funnel.h2Text}>Suburb Transportation</h2>
        <Box sx={{ display: "flex" }}>
          <FormControl
            sx={{ m: 0, ml: 3, mr: 3 }}
            component="fieldset"
            variant="standard"
          >
            <FormGroup>
              {Train}
              {Tram}
              {Metro}
              {Ferry}
            </FormGroup>
          </FormControl>
        </Box>
      </div>
    </Box>
  );
}

export default Transportation;
